type Courses =
  | '11+'
  | 'KS3'
  | 'GCSE'
  | 'GCSE Further'
  | 'GCSE Additional'
  | 'IGCSE'
  | 'IGCSE Additional'
  | 'IGCSE Further'
  | 'AS Level (GCE)'
  | 'A Level (GCE)'
  | 'AS Level Further (GCE)'
  | 'A Level Further (GCE)'
  | 'International A Level'
  | 'AP Calculus AB'
  | 'AP Calculus BC'
  | 'AP Statistics'
  | 'IB'
  | 'UKMT'
  | 'STEP'
  | 'MAT'
  | 'TMUA'
  | 'Uni';

const showExamBoard: Courses[] = [
  'GCSE',
  'GCSE Further',
  'GCSE Additional',
  'IGCSE',
  'IGCSE Additional',
  'IGCSE Further',
  'AS Level (GCE)',
  'A Level (GCE)',
  'AS Level Further (GCE)',
  'A Level Further (GCE)',
  'International A Level',
  'UKMT',
];

const showTier: Courses[] = ['GCSE', 'IGCSE', 'UKMT'];

const showModule: Courses[] = [
  'AS Level (GCE)',
  'A Level (GCE)',
  'AS Level Further (GCE)',
  'A Level Further (GCE)',
  'International A Level',
  'IB',
  'UKMT',
  'Uni',
];

const showDocumentType: Courses[] = [
  '11+',
  'KS3',
  'GCSE',
  'GCSE Further',
  'GCSE Additional',
  'IGCSE',
  'IGCSE Additional',
  'IGCSE Further',
  'AS Level (GCE)',
  'A Level (GCE)',
  'AS Level Further (GCE)',
  'A Level Further (GCE)',
  'International A Level',
  'AP Calculus AB',
  'AP Calculus BC',
  'AP Statistics',
  'IB',
  'STEP',
  'MAT',
  'TMUA',
  'Uni',
];

export { showExamBoard, showTier, showModule, showDocumentType };
